// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Footer-module--anchor--2dPg7","wrapper":"Footer-module--wrapper--35AQS","icon":"Footer-module--icon--Xc-aO","link":"Footer-module--link--2WPgG"};